import React from "react";
import { TextField, MenuItem } from "@mui/material";

export interface FormFieldProps {
  id: string;
  label: React.ReactNode;
  value: string;
  onChange: (val: string) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  refProp?: React.Ref<any>;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  type?: "text" | "select";
  options?: { label: string; value: string }[];
}

const FormField: React.FC<FormFieldProps> = ({ label, value, onChange, onKeyPress, refProp, disabled, error, helperText, type = "text", options = [] }) => (
  <TextField
    select={type === "select"}
    fullWidth
    label={label}
    variant="outlined"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    onKeyPress={onKeyPress}
    inputRef={refProp}
    disabled={disabled}
    error={error}
    helperText={helperText}
    margin="normal"
  >
    {type === "select" &&
      options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
  </TextField>
);

export default FormField;
